import {captureMessarioLaunchFragment} from '@lib/messarioLaunch/fragment';

const messarioLaunchFragment = captureMessarioLaunchFragment();

export default messarioLaunchFragment;

// HMR boundary: the fragment is captured once per page load; a hot update must not re-read the URL.
if(import.meta.hot) import.meta.hot.accept();
